import { Table } from 'antd';
import { InventoryOutputDialogWrapper } from '../InventoryReportStyled';
import { INVENTORY_REPORT_CONSTANT } from '../constant';

const { TITLE, DIALOG } = INVENTORY_REPORT_CONSTANT;

interface InventoryOutputConfirmDialogProps {
  open: boolean;
  loading: boolean;
  periodDisplay: string;
  storeDisplay: string;
  onCancel: () => void;
  onOk: () => void;
}

const columns = [
  { title: '項目名', dataIndex: 'label', key: 'label', width: '40%' },
  { title: '出力条件', dataIndex: 'value', key: 'value' },
];

/**
 * VAMS_PC_007_01 出力確認 dialog.
 * [D1] container / [D1.1] close × (mặc định Modal closeIcon — cùng hành vi với [D4])
 * [D2] message xác nhận / [D3] bảng tóm tắt 棚卸年月 + 出力対象店舗 (không gọi API riêng — dùng state hiện tại)
 * [D4] キャンセル / [D5] OK (loading khi đang "gọi API" tạo PDF — mock trong hook useInventoryReport).
 */
export function InventoryOutputConfirmDialog({
  open,
  loading,
  periodDisplay,
  storeDisplay,
  onCancel,
  onOk,
}: InventoryOutputConfirmDialogProps) {
  const dataSource = [
    { key: 'period', label: DIALOG.LABEL_PERIOD, value: periodDisplay || '—' },
    { key: 'store', label: DIALOG.LABEL_STORE, value: storeDisplay || '—' },
  ];

  return (
    <InventoryOutputDialogWrapper
      open={open}
      title={TITLE.OUTPUT_CONFIRM_TITLE}
      maskClosable={false}
      confirmLoading={loading}
      onCancel={onCancel}
      cancelText={TITLE.BTN_CANCEL}
      okText={TITLE.BTN_OK}
      onOk={onOk}
      width={480}
    >
      <p className="output-confirm_message">{DIALOG.MESSAGE}</p>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        size="small"
        bordered
      />
    </InventoryOutputDialogWrapper>
  );
}
